import request from "@/utils/request";

export function apiListCustomer(params) {
  return request.get("/customer/list", params);
}

export function apiDetailCustomer(params) {
  return request.get("/customer/detail", params);
}

export function apiAddCustomer(params) {
  return request.post("/customer/add", params);
}

export function apiEditCustomer(params) {
  return request.post("/customer/edit", params);
}

export function apiResetCustomerPassword(params) {
  return request.post("/customer/resetPassword", params);
}

export function apiCustomerSiteOptions() {
  return request.get("/customer/siteOptions");
}
